import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { CSSTransition } from 'react-transition-group';

import { useTranslation } from '@gem/modules/i18n';

import { useSignInDeviceRequestsToastPresenter } from './SignInDeviceRequestsToast.presenter';
import styles from './SignInDeviceRequestsToast.styles.m.css';

const ANIMATION_TIMEOUT = 250;

const itemTransition = {
  enter: styles.enter,
  enterActive: styles.enterActive,
  exit: styles.exit,
  exitActive: styles.exitActive,
};

export const SignInDeviceRequestsToast: FC = observer(() => {
  const { t } = useTranslation();
  const presenter = useSignInDeviceRequestsToastPresenter();

  return (
    <CSSTransition
      in={!!presenter.deviceRequest && !presenter.isPopupShown}
      classNames={itemTransition}
      timeout={ANIMATION_TIMEOUT}
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.event}>
        <div className={styles.eventText}>{t('trusted_device_new_sign_in_request')}</div>
        <button
          className={styles.eventButton}
          onClick={presenter.showRequest}
        >
          {t('common_view')}
        </button>
      </div>
    </CSSTransition>
  );
});
